import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { GcloudAccesses } from "./accesses.ts";
import { GcloudComponents } from "./components.ts";
import { GcloudIconUrl } from "./icon.ts";

const GcloudFilters = {
  permission: { keys: ["id"] },
  project: { keys: ["id"] },
  resource: { keys: ["full-resource-name", "name", "type"] },
  role: { keys: ["id"] },
} as const satisfies AnyFilterSchema;

export type GcloudFilters = typeof GcloudFilters;

export const GcloudRegistration = Registration({
  accesses: GcloudAccesses,
  category: "resource",
  components: GcloudComponents,
  docs: {
    install: "google-cloud",
    request: "google-cloud/requesting-access",
  },
  filters: GcloudFilters,
  identifier: (use) => (use === "function-caller" ? "name" : "identifier"),
  itemKind: (use) =>
    use === "function-caller" ? "Cloud Run service" : "project",
  label: "Google Cloud",
  logoUrl: GcloudIconUrl,
  maturity: "ga",
  requestType: "requestable",
  useMapping: [
    { use: "iam_write", component: "iam-write" },
    { use: "iam_read", component: "iam-assessment" },
    { use: "iam_read", component: "org-iam-assessment" },
    { use: "function-caller", component: "function-caller" },
    { use: "rotate_keys", component: "key-rotation" },
  ],
});

registerIntegration("gcloud", GcloudRegistration);
